import { WORDS } from '../constants/wordlist'
import { VALIDGUESSES } from '../constants/validGuesses'
import { CONFIG } from '../constants/config'

export const isWordInWordList = (word: string) => {
  return WORDS.includes(word) || VALIDGUESSES.includes(word)
}

export const isWinningWord = (word: string) => {
  return solution === word
}

const hashDate = (year: number, month: number, day: number): number => {
  // Pack date into a single integer, then apply a splitmix32-style hash
  // for even distribution. Same date always produces the same value.
  let h = year * 10000 + (month + 1) * 100 + day
  h = Math.imul(h ^ (h >>> 16), 0x45d9f3b)
  h = Math.imul(h ^ (h >>> 16), 0x45d9f3b)
  h = h ^ (h >>> 16)
  // Use WORDS.length so the index is always within the bounds of the word list.
  return Math.abs(h) % WORDS.length
}

export const getWordOfDay = () => {
  // All users see the same "date" by subtracting a fixed UTC-8 offset before
  // reading UTC fields. This is intentionally a fixed UTC-8 offset (not
  // America/Los_Angeles), so the rollover is always at the same UTC instant
  // regardless of DST.
  const UTC_OFFSET_MS = 8 * 60 * 60 * 1000
  const pacificNow = new Date(Date.now() - UTC_OFFSET_MS)
  const year = pacificNow.getUTCFullYear()
  const month = pacificNow.getUTCMonth()
  const day = pacificNow.getUTCDate()

  // Use hashing only to select the word. Keep a separate monotonic day count
  // as the puzzle identifier so that puzzle numbers are always unique and
  // increasing (hashed values repeat once the list wraps around).
  const wordIndex = hashDate(year, month, day)
  const epochMs = new Date(CONFIG.startDate).valueOf()
  const todayMs = Date.UTC(year, month, day)
  const solutionIndex = Math.max(0, Math.floor((todayMs - epochMs) / 86400000))

  // Next midnight UTC-8 expressed as a UTC timestamp — identical for every
  // user worldwide, so countdown timers all reach zero at the same instant.
  const tomorrow = Date.UTC(year, month, day + 1) + UTC_OFFSET_MS

  return {
    solution: WORDS[wordIndex],
    solutionIndex,
    tomorrow,
  }
}

export const { solution, solutionIndex, tomorrow } = getWordOfDay()
